import React from 'react'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'

import Grid from '@softwaredev_cegeka/stix-core/dist/components/Grid'
import Notifier from '@softwaredev_cegeka/stix-notifier/dist/components/Notifier'

import NotFound from './NotFound'
import InternalServerError from './InternalServerError'
import UnauthorizedPage from './UnauthorizedPage'
import ErrorBoundary from 'src/components/ErrorBoundary'
import withUserData from 'src/components/auth/withUserData'
import { routeConfig } from './config'
import { ContentRoute } from './ContentRoute'
import Permission from 'src/components/auth/Permission'
import AuthTokenUpdater from 'src/components/auth/authTokenUpdater'
import { RouteLoader } from 'src/components/Loader'
import ExportCompleteNotifier from 'src/components/ExportCompleteNotifier'

class Main extends React.Component {
    render() {
        return (
            <AuthTokenUpdater>
                <Router>
                    <Grid.Container fluid className="site-container">
                        <Switch>
                            {/* this needs to be outside because we redirect to it from the ErrorBoundary*/}
                            <Route
                                exact
                                path={'/internal-error'}
                                component={InternalServerError}
                            />
                            <Route>
                                <Permission>
                                    <ErrorBoundary>
                                        <Notifier>
                                            <ExportCompleteNotifier />
                                            <React.Suspense
                                                fallback={<RouteLoader />}
                                            >
                                                <Switch>
                                                    {routeConfig.map(
                                                        (route, index) => {
                                                            if (
                                                                route.permissions instanceof
                                                                Function
                                                            ) {
                                                                if (
                                                                    !route.permissions(
                                                                        this
                                                                            .props
                                                                            .userData,
                                                                        this
                                                                            .props
                                                                            .location
                                                                            .pathname
                                                                    )
                                                                ) {
                                                                    return (
                                                                        <Route
                                                                            key={`${route.title}-${index}`}
                                                                            path={
                                                                                route.path
                                                                            }
                                                                            exact
                                                                            component={
                                                                                UnauthorizedPage
                                                                            }
                                                                        />
                                                                    )
                                                                }
                                                            }
                                                            return (
                                                                <ContentRoute
                                                                    key={`${route.title}-${index}`}
                                                                    match={
                                                                        this
                                                                            .props
                                                                            .match
                                                                    }
                                                                    path={
                                                                        route.path
                                                                    }
                                                                    component={
                                                                        route.component
                                                                    }
                                                                    title={
                                                                        route.title
                                                                    }
                                                                    name={
                                                                        route.name
                                                                    }
                                                                    breadcrumbs={
                                                                        route.breadcrumbs
                                                                    }
                                                                />
                                                            )
                                                        }
                                                    )}
                                                    <Route
                                                        component={NotFound}
                                                    />
                                                </Switch>
                                            </React.Suspense>
                                        </Notifier>
                                    </ErrorBoundary>
                                </Permission>
                            </Route>
                        </Switch>
                    </Grid.Container>
                </Router>
            </AuthTokenUpdater>
        )
    }
}

export default withUserData(Main)
